/**
 * Log severity levels in ascending order.
 * Used to filter logs based on environment configuration.
 *
 * Extracted to its own file to avoid circular dependency between
 * environment files and LoggerService.
 */
export enum LogLevel {
  debug = 0,
  info = 1,
  warn = 2,
  error = 3,
}
